import React from "react";
import { useContent } from "../App";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { AdSlot } from "../components/AdSlot";
import { ChapterSection } from "../components/ChapterSection";
import { BridgeSection } from "../components/BridgeSection";
import { ProductsSection } from "../components/ProductsSection";
import { AnalyzersSection } from "../components/AnalyzersSection";
import { FaqSection } from "../components/FaqSection";
import { EmailCapture } from "../components/EmailCapture";
import { Footer } from "../components/Footer";
import { LogoTile } from "../components/Logo";

const LandingPage = () => {
    const content = useContent();

    if (!content) {
        return (
            <div className="flex min-h-screen items-center justify-center bg-[#FDFCF8]">
                <div className="animate-pulse" data-testid="landing-loading">
                    <LogoTile size={52} />
                </div>
            </div>
        );
    }

    const { content: c, products, config } = content;
    const publisherId = config?.adsense_publisher_id || "";

    return (
        <div data-testid="landing-page" className="bg-[#FDFCF8] text-[#1A1D1A]">
            <Header />
            <main className="max-w-[760px] mx-auto px-4 sm:px-6">
                <Hero hero={c.hero} />
            </main>
            <Marquee />
            <main className="max-w-[760px] mx-auto px-4 sm:px-6">
                <AdSlot slotId="ad-slot-top" publisherId={publisherId} />
                <ChapterSection id="causes" data={c.causes} testIdPrefix="cause" itemIdPrefix="cause" eyebrow="The why" />
                <BridgeSection data={c.bridge} />
                <AdSlot slotId="ad-slot-mid" publisherId={publisherId} />
                <ChapterSection id="solutions" data={c.solutions} testIdPrefix="solution" itemIdPrefix="solution" eyebrow="The fix" />
                <ProductsSection section={c.products_section} products={products} />
                <AnalyzersSection section={c.analyzers} products={products} />
                <AdSlot slotId="ad-slot-bottom" publisherId={publisherId} />
                <FaqSection data={c.faq} />
                <EmailCapture data={c.email} />
            </main>
            <Footer footer={c.footer} />
        </div>
    );
};

export default LandingPage;
